import { AntDesign } from '@expo/vector-icons';
import React from 'react';

function RightArrow(): React.JSX.Element {
  return <AntDesign testID="btnAccordianImage" name="right" size={16} color="black" />;
}

export default RightArrow;
